/**
 * Replacement of an internal transform() logic of TitleCasePipeFormat
 */
export function titleCaseFormat(value: string): string {
  if (!value) {
    return '';
  }

  const lang = localStorage.getItem('lang');
  if (lang === 'en') {
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => (word.length > 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()))
      .join(' ');
  } else {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
